import React from 'react';
import {Grid, rgbToHex, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import {InferPropTypes} from 'commons/types/Types';
import {ItemColorStyles} from 'assets/tss/layouts/blank';

function ItemColor(
    props: InferPropTypes<typeof ItemColor.propTypes, typeof ItemColorStyles>
) {
    const {classes, color, name} = props;
    return (
        <Grid item container xs={12} sm={4} md={4} className={classes.color}>
            <Grid item xs={3} sm={4} md={3} style={{backgroundColor: color}} />
            <Grid item xs={12} sm={7} md={8}>
                <Typography variant='body2'>{name}</Typography>
                <Typography variant='body2' color='textPrimary'>
                    {rgbToHex(color)}
                </Typography>
            </Grid>
        </Grid>
    );
}

ItemColor.propTypes = {
    color: PropTypes.any,
    name: PropTypes.string,
};

export default withStyles(ItemColorStyles)(ItemColor);
